import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import AOS from "aos";
import Footer from "../component/Layout/Footer";
// import Header from "../component/Layout/Header";
import HomePage from "../pages/HomePage";
import ScrollToTop from "./ScrollToTop";
import ScrollToTopBtn from "../component/ScrollToTop";
import MagazinePage from "../pages/MagazinePage";
import TravelPage from "../pages/TravelPage";
import ContactPage from "../pages/ContactPage";
import LitepaperPage from "../pages/LitepaperPage";
// Private Sale page + promo banner temporarily hidden — not ready to go live yet.
// import PrivateSalePage from "../pages/PrivateSalePage";
// import PromoBanner from "../component/PromoBanner";


const MainRoutes = () => {
  useEffect(() => {
    AOS.init();
  }, []);
  return (
    <Router>
      {/* <Header /> */}
      {/* <PromoBanner /> */}
      <ScrollToTop>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/magazine" element={<MagazinePage />} />
          <Route path="/travel" element={<TravelPage />} />
          <Route path="/contacts" element={<ContactPage />} />
          <Route path="/litepaper" element={<LitepaperPage />} />
          {/* <Route path="/private-sale" element={<PrivateSalePage />} /> */}
        </Routes>
      </ScrollToTop>
      <Footer />
      <ScrollToTopBtn />
    </Router>
  );
};

export default MainRoutes;
